<template>
    <div class="tw-flex tw-flex-col sm:tw-flex-row md:tw-flex-col tw-max-w-48 tw-w-full">
        <span class="tw-flex tw-justify-between">
            <a
                :href="termsOfUse"
                class="tw-text-gray-700 tw-underline tw-font-medium tw-transition-colors tw-duration-200 hover:tw-text-gray-300"
                target="_blank"
            >
                Terms of Use
            </a>
            <span class="tw-text-gray-700">|</span>
            <a
                :href="privacyPolicyUrl"
                class="tw-text-gray-700 tw-underline tw-font-medium tw-transition-colors tw-duration-200 hover:tw-text-gray-300"
                target="_blank"
            >
                Privacy Policy
            </a>
        </span>
    </div>
</template>

<script>
export default {
    name: 'TermsAndPolicies',
    components: {},
    mixins: [],
    props: {
        termsOfUse: {
            type: String,
            required: false,
        },
        privacyPolicyUrl: {
            type: String,
            required: false,
        },
    },
    data() {
        return {};
    },
    computed: {

    },
    methods: {

    },

};
</script>
